import { Box, Stack, Typography } from '@mui/material';
import { FC } from 'react';

import { useTheme } from '@mui/material/styles';
import { CheckOutlined } from '@mui/icons-material';

type Props = {
	readonly setSelectedOption: (option: string) => void;
	readonly title: string;
	readonly desc: string;
	readonly name: string;
	readonly icon: JSX.Element;
	readonly iconBackground?: string;
	readonly disabled?: boolean;
	readonly selectedOption?: string;
};

const PersonaCreateOption: FC<Props> = ({
	setSelectedOption: setActiveOption,
	title,
	desc,
	name,
	icon,
	iconBackground,
	disabled,
	selectedOption: active,
}) => {
	const theme = useTheme();

	return (
		<>
			<Box
				width={'100%'}
				minHeight={'90px'}
				border={1}
				borderRadius={'6px'}
				borderColor={theme.palette.grey[200]}
				padding={1.5}
				gap={2}
				display={'flex'}
				flexDirection={'row'}
				position={'relative'}
				sx={
					disabled
						? {
								cursor: 'not-allowed',
								backgroundColor: theme.palette.grey[100],
								color: theme.palette.grey[500],
							}
						: active === name
							? {
									cursor: 'pointer',
									border: '2px solid',
									borderColor: theme.palette.primary[400],
								}
							: {
									cursor: 'pointer',
									'&:hover': {
										borderColor: theme.palette.grey[300],
									},
								}
				}
				onClick={() => (disabled ? null : setActiveOption(name))}
			>
				{active === name ? (
					<Box
						position={'absolute'}
						top={8}
						right={8}
						width={20}
						height={20}
						borderRadius={5}
						sx={{ backgroundColor: theme.palette.primary[400] }}
						display={'flex'}
						alignItems={'center'}
						justifyContent={'center'}
					>
						<CheckOutlined sx={{ width: '16px', height: '16px' }} htmlColor={theme.palette.grey[0]} />
					</Box>
				) : null}
				<Stack direction={'row'}>
					<Box
						width={'64px'}
						height={'64px'}
						borderRadius={'6px'}
						sx={{ backgroundColor: iconBackground ?? theme.palette.grey[200] }}
						display={'flex'}
						justifyContent={'center'}
						alignItems={'center'}
					>
						{icon}
					</Box>
				</Stack>
				<Stack direction={'column'}>
					<Typography>{title}</Typography>
					<Typography variant={'body2'} color={theme.palette.grey[500]}>
						{desc}
					</Typography>
				</Stack>
			</Box>
		</>
	);
};

export { PersonaCreateOption };
